export default "__VITE_ASSET__XcFh7yLKgKT$LYDcTgyccQ__"